import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import Linkify from "~/components/Linkify";
import { centralizedClipDescriptionSelector } from "~/store/centralizedClip/selectors";
export const InfoPanelDescription = /*#__PURE__*/ memo(()=>{
    const description = useSelector(centralizedClipDescriptionSelector);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex w-full items-center justify-between px-2 py-1.5",
        children: /*#__PURE__*/ _jsx("span", {
            className: "w-full break-words text-14 text-grey-11",
            children: /*#__PURE__*/ _jsx(Linkify, {
                children: description
            })
        })
    });
});
InfoPanelDescription.displayName = "InfoPanelDescription";
